import React from "react";
import { useTranslation } from "react-i18next";
import { Banner } from "@rentablo/components";
import { useMyself } from "@api";
import {
  endImpersonation,
  isImpersonating,
} from "@features/login/impersonate/impersonateTokenHandler";

export const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const { data: user } = useMyself();

  // Impersonation state only changes via full page reloads (start/end), so a
  // render-time read of localStorage is always current — no reactivity needed.
  if (!isImpersonating()) return null;

  const handleEnd = () => {
    endImpersonation();
    // Full reload back to the app (V2) as the restored admin — mirrors the
    // redirect used when impersonation starts.
    window.location.href = import.meta.env.VITE_APP_V2_URL || "/";
  };

  const userLabel = user?.name || user?.email || "";

  return (
    <Banner
      type="warn"
      displayDefaultIcon
      title={t("impersonation.banner", { user: userLabel })}
      primaryButton={{
        label: t("impersonation.end"),
        onClick: handleEnd,
        variant: "outlined",
        color: "warning",
      }}
      m={4}
      sx={{
        position: "sticky",
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    />
  );
};
